/*eslint-disable react-hooks/exhaustive-deps*/
import React, { useEffect, useState } from "react";
import { Grid, Loading } from "../../core";
import { FormOutlined, UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { theme } from "../../styles";
import { Row, Avatar } from "antd";

import { getSpecificCompany } from "../../helper/utils/api/company";
import EditCompanyModal from "../../components/Modals/Comapny/editCompanyModal";
const { colors } = theme;

const Container = styled.div`
  .edit-icon--wraper {
    text-align: right;
    svg {
      width: 20.12px;
      height: 20.12px;
      color: ${colors.Fiord};
    }
  }
  .b-5 {
    border: 2px solid #233b67;
  }
`;
const GeneralInfo = styled.div`
  .label--text {
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    margin: 20px 0px;
    color: #404e67;
    > span {
      color: #6789c5 !important;
      font-weight: unset !important;
      margin: 0px 5px;
    }
  }
`;
const General = () => {
  let companyId = localStorage.getItem("companyId");
  let userId = useSelector((state) => state.auth.userDetail._id);
  const [companyData, setCompanyData] = React.useState({});

  const [modalState, setModalState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // let companyId = localStorage.getItem("companyId");

  useEffect(() => {
    getCompanyData();
  }, [userId]);

  const getCompanyData = async () => {
    if (companyId && userId) {
      setIsLoading(true);
      try {
        let resonse = await getSpecificCompany({ userId, companyId });
        setCompanyData(resonse.data.result[0]);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log("error=>", error);
      }
    }
  };
  // const [state, dispatch] = useReducer(reducer, initialState);
  // const [form] = Form.useForm();
  // const company_id = parseInt(localStorage.getItem("company_id"));
  // console.log(company_id);
  // const companies = useSelector((state) => state.createCompany.company);
  // const singleCompany = companies.filter((data) => {
  //   return data.id === company_id;
  // })[0];
  // const onCreate = (values) => {
  //   dispatch({ type: "MODAL_VIEW", payload: false });
  // };
  // const onCancel = (values) => {
  //   dispatch({ type: "MODAL_VIEW", payload: false });
  // };
  // if (!singleCompany) {
  //   return <Loading />;
  // }

  const openModal = (name) => {
    setModalState(true);
  };

  const closeModal = (name) => {
    setModalState(false);
  };
  return (
    <React.Fragment>
      {isLoading ? <Loading /> : null}
      <Grid>
        <Container>
          <div className="edit-icon--wraper">
            <FormOutlined
              color="#404E67"
              onClick={() => openModal("editCompany")}
            />
          </div>
          <Row type="flex" justify="center">
            <Avatar
              className="b-5"
              size={120}
              icon={<UserOutlined />}
              src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
            />
          </Row>
          <GeneralInfo className="mt-40">
            <div className="label--text">
              Company Name : <span>{companyData.companyName || ""}</span>
            </div>
            <div className="label--text">
              Company Email : <span>{companyData.companyEmail || ""}</span>
            </div>
            <div className="label--text">
              NTN : <span>{companyData.NTN || ""}</span>
            </div>
            <div className="label--text">
              STRN : <span>{companyData.STRN || ""}</span>
            </div>
            <div className="label--text">
              Phone Number : <span>{companyData.phoneNumber || ""}</span>
            </div>
            <div className="label--text">
              Company Address : <span>{companyData.companyAddress || ""}</span>
            </div>
          </GeneralInfo>
        </Container>
      </Grid>

      {modalState && (
        <EditCompanyModal
          modalState={modalState}
          companyData={companyData}
          closeModal={closeModal}
          getCompanyData={getCompanyData}
        />
      )}
    </React.Fragment>
  );
};

export default General;
